import * as React from 'react';
import { flow } from 'lodash';
import { connect } from 'react-redux';
import { Row } from 'react-bootstrap';
import { push } from 'react-router-redux';
import { bindActionCreators } from 'redux';
import { IStore } from '../../../../redux/IStore';
import { reduxForm, formValueSelector } from 'redux-form';
import { IAuthState } from '../../../../services/auth/models';
import CreateAnAccountForm from './components/CreateAnAccountForm';
import { actions as authActions, IAuthActions } from '../../../../services/auth/reducer';

interface ICreateAnAccountProps {
  auth: IAuthState;
  actions: {
    auth: IAuthActions;
    push: (route: string) => void;
  };
}

class CreateAnAccount extends React.Component<ICreateAnAccountProps> {
  private handleSubmit = (values) => {
    const { actions } = this.props;

    actions.auth.createAccount(values.email);
  }

  public render() {
    const { auth } = this.props;

    return (
      <Row className="page-container animated fadeIn">
        <div className="customer-section-title">
          <h1>Create your personal space</h1>
        </div>
        {!auth.createAccount ? (
          <span>
            <h4>Please complete the fields below</h4>
            <CreateAnAccountForm onSubmit={this.handleSubmit}/>
          </span>
        ) : (
          <div className="blue-section">
            <p>
              Click on the link contained in the email that we have just sent to you to register
              Your password.
            </p>
            <p>
              If this email has not reached you in the next 5 minutes, we will
              invite you to check your "junk mail" folder.
            </p>
            <p><u>Important</u> : the link contained in the mail will expire in 1 hour.</p>
          </div>
        )}
      </Row>
    );
  }
}

let selector;

export default flow([
  reduxForm({
    form: 'create-an-account',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {
    selector = formValueSelector('create-an-account');

    return component;
  },
  connect(
    (state: IStore) => {
      return {
        auth: state.auth,
      };
    },
    (dispatch) => ({
      actions: {
        push: bindActionCreators(push, dispatch),
        auth: bindActionCreators({ ...authActions }, dispatch),
      },
    }),
  ),
])(CreateAnAccount);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/CustomerArea/scenes/CreateAnAccount/index.tsx